export default __webpack_public_path__ + "static/media/ci-icon-info.3cb227d1.svg";